import { render, staticRenderFns } from "./TolBillingMethod.vue?vue&type=template&id=b06b44f4&scoped=true&"
import script from "./TolBillingMethod.vue?vue&type=script&lang=js&"
export * from "./TolBillingMethod.vue?vue&type=script&lang=js&"
import style0 from "./TolBillingMethod.vue?vue&type=style&index=0&id=b06b44f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b44f4",
  null
  
)

export default component.exports